import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import loadable from "@loadable/component"
// import GoogleLogo from "../../images/google-logo.png"
// import ReviewsBlock from "./ReviewsBlock";
// import Pagination from "../../components/Pagination/Pagination"
// import { isMobileOnly, isTablet, isIPad13, isIOS13 } from "react-device-detect";
import { AppendScript } from "../../common/utils/site_utlis";
// import ReactPaginate from 'react-paginate';
import ContentModule from "../../modules/content_module";

const ReactPaginate = loadable(() => import("react-paginate"));

import {Grid} from "@dadoagency/gatsby-plugin-trustpilot-widget";

import "./ClientReview.scss";
const AllAgentReview = ({ Module }) => {

    // useEffect(() => {
        
    //     if(typeof window !== "undefined"){
    //         AppendScript("https://www.allagents.co.uk/widgets/reviews.min.js", "allagents_review", () => {
    //           setTimeout(()=>{
    //             window.init_widget_v2('100%', 1200, 2319, 20, "date", "4")
    //           },1500)          
    //         });
    //     }
        
    // }, []);

    return (
        <React.Fragment>
            <section className="client-reviews all-agent-review">
                <Container>
                    <Row>
                        <Col>
                            <div className="review-wrapper">
                                {Module.title && <h3>{Module.title}</h3> }
                                {Module.description && <ContentModule Content={Module.description} /> }
                                
                                <div className="content-wrap">
                                    {/* <div id="wd_id"></div> */}

                                    <Grid 
                                        language="en"
                                        culture="US"
                                        theme="light"
                                        width="100%"
                                        height="500px"
                                        stars="4,5"
                                    />
                                </div>
                            </div>
                          
                        </Col>
                    </Row>


                </Container>
            </section>
        </React.Fragment>
    );
};
export default AllAgentReview;
